import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0d197a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "app__page__title__container" }
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Administrare categorii")
const _hoisted_6 = { style: {"margin-left":"auto"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Adauga categorie de baza noua! ")
const _hoisted_8 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_9 = { class: "app__label--large" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Stergere")
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Modifica")
const _hoisted_16 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_17 = { class: "app__label--medium" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Stergere")
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Modifica")
const _hoisted_24 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_25 = { class: "app__label--small" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Stergere")
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Modifica")
const _hoisted_32 = {
  key: 3,
  style: {"display":"flex"}
}
const _hoisted_33 = { class: "app__label--small" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Stergere")
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Modifica")
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_42 = {
  key: 2,
  class: "app__title--small",
  style: {"position":"absolute","left":"calc(50% - 100px)"}
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_44 = { class: "flex__column--center" }
const _hoisted_45 = {
  key: 0,
  class: "app__color--gray"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode("categoria parinte: ")
const _hoisted_47 = { class: "app__property--medium" }
const _hoisted_48 = {
  key: 2,
  class: "app__label--medium"
}
const _hoisted_49 = { class: "flex__column--center" }
const _hoisted_50 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Pick Files")
const _hoisted_52 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_53 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","padding-bottom":"1rem"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__label--large q-mx-sm" }, "Unitati de masura", -1))
const _hoisted_55 = { class: "draggable__list--area" }
const _hoisted_56 = { style: {"grid-area":"notselected"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__title--small" }, "Caracteristici inactive", -1))
const _hoisted_58 = {
  class: "draggable__list--element",
  style: {"background-color":"rgba(167,151,42,0.13)"}
}
const _hoisted_59 = { class: "app__property--medium" }
const _hoisted_60 = { style: {"grid-area":"selected"} }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app__title--small" }, "Caracteristici active", -1))
const _hoisted_62 = { class: "draggable__list--element" }
const _hoisted_63 = { class: "app__property--medium" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode()
const _hoisted_65 = { class: "app__details--medium" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app__color--gray",
  style: {"grid-area":"help","text-align":"center","padding":"0.5rem"}
}, "Tine apasat si trage pentru a modifica!", -1))
const _hoisted_67 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tree = _resolveComponent("q-tree")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_uploader_add_trigger = _resolveComponent("q-uploader-add-trigger")!
  const _component_q_uploader = _resolveComponent("q-uploader")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_q_icon, {
            name: "category",
            style: {"font-size":"2rem","top":"-3px"},
            color: "primary"
          }),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              style: {"margin-top":"1rem","margin-right":"1rem"},
              padding: "xs",
              color: "blue",
              icon: "add",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFormAddNewCategory('','')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_input, {
      outlined: "",
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
      label: "Cautare",
      dense: ""
    }, {
      append: _withCtx(() => [
        (_ctx.filter !== '')
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "clear",
              class: "cursor-pointer",
              onClick: _ctx.resetFilter
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_tree, {
      nodes: _ctx.treeDataCategories,
      "node-key": "appid",
      filter: _ctx.filter,
      "filter-method": _ctx.myFilterMethod,
      "default-expand-all": true,
      ref: "refTreeGrid"
    }, {
      "default-header": _withCtx((prop) => [
        (prop.node.category_level=='1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(prop.node.name), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name))
                  }, [
                    _hoisted_11,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_14,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ], 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true),
        (prop.node.category_level=='2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(prop.node.name), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name))
                  }, [
                    _hoisted_19,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_22,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ], 8, _hoisted_21)
            ]))
          : _createCommentVNode("", true),
        (prop.node.category_level=='3')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(prop.node.name), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name))
                  }, [
                    _hoisted_27,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_26))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_30,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                })
              ], 8, _hoisted_29)
            ]))
          : _createCommentVNode("", true),
        (prop.node.category_level=='4')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(prop.node.name), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name))
                  }, [
                    _hoisted_35,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_34))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_38,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                })
              ], 8, _hoisted_37)
            ]))
          : _createCommentVNode("", true)
      ]),
      "default-body": _withCtx((prop) => [
        (prop.node.is_parent_for_articles=='n')
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createVNode(_component_q_btn, {
                outline: "",
                color: "primary",
                icon: "add",
                label: "subcategorie noua",
                size: "sm",
                "no-caps": "",
                onClick: ($event: any) => (_ctx.openFormAddNewCategory(prop.node.pid,prop.node.name))
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["nodes", "filter", "filter-method"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isOpenDialogCategory,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isOpenDialogCategory) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      color: "blue",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "arrow_back_ios",
                          style: {"font-weight":"bold"}
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Editeaza categorie"))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Editeaza categorie"))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 3,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      dense: "",
                      flat: "",
                      icon: "close",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"85vh","max-width":"99vw"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_q_form, {
                        onSubmit: _ctx.onSubmitFormCategory,
                        onReset: _ctx.onResetFormCategory,
                        class: "q-gutter-md"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_input, {
                            outlined: "",
                            modelValue: _ctx.editingCategory.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingCategory.name) = $event)),
                            label: _ctx.label_editing_category,
                            "input-style": "text-transform: uppercase;color:black;font-weight: 900;",
                            counter: "",
                            style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                            maxlength: "100",
                            rules: [val => !!val || 'Field is required']
                          }, null, 8, ["modelValue", "label", "rules"]),
                          (_ctx.editingCategory.parent_pid && _ctx.editingCategory.parent_pid.toString().length>0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.editingCategory.parent_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.editingCategory.hasChilds=='n')
                            ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                key: 1,
                                modelValue: _ctx.editingCategory.is_parent_for_articles,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingCategory.is_parent_for_articles) = $event)),
                                label: "Contine articole (nu mai exista subcategorii)",
                                color: "teal",
                                "true-value": "y",
                                "false-value": "n"
                              }, null, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_48, "Exista subcategorii!")),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_q_uploader, {
                              ref: "inputImgForCategory",
                              label: "Incarca o imagine pentru categorie",
                              accept: ".jpg, .png, image/*",
                              "auto-upload": false,
                              color: "grey",
                              flat: "",
                              "hide-upload-button": true,
                              multiple: false,
                              style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                              onAdded: _ctx.imgForCategoryWasAdded
                            }, {
                              header: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_50, [
                                  (scope.isUploading)
                                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                                        key: 0,
                                        class: "q-uploader__spinner"
                                      }))
                                    : _createCommentVNode("", true),
                                  (scope.canAddFiles)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        type: "a",
                                        icon: "add_box",
                                        round: "",
                                        dense: "",
                                        flat: "",
                                        label: "Incarca imagine categorie"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_uploader_add_trigger),
                                          _createVNode(_component_q_tooltip, null, {
                                            default: _withCtx(() => [
                                              _hoisted_51
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["onAdded"]),
                            (_ctx.ImgCategoryString64.length>0 && _ctx.editingCategory.img==null)
                              ? (_openBlock(), _createBlock(_component_q_img, {
                                  key: 0,
                                  src: _ctx.ImgCategoryString64,
                                  "spinner-color": "white",
                                  style: {"min-width":"100px","max-width":"clamp(100px,50vw, 300px)","top":"-50px","margin":"auto"}
                                }, {
                                  loading: _withCtx(() => [
                                    _createVNode(_component_q_spinner_gears, { color: "white" })
                                  ]),
                                  _: 1
                                }, 8, ["src"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.editingCategory.is_parent_for_articles=='y')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                (1==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _hoisted_54,
                                      _createVNode(_component_q_select, {
                                        outlined: "",
                                        class: "q-mx-sm",
                                        modelValue: _ctx.editingCategory.um1,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingCategory.um1) = $event)),
                                        options: _ctx.optionsUM,
                                        label: "UM1",
                                        style: {"width":"100px"}
                                      }, null, 8, ["modelValue", "options"]),
                                      _createVNode(_component_q_select, {
                                        outlined: "",
                                        modelValue: _ctx.editingCategory.um2,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingCategory.um2) = $event)),
                                        options: _ctx.optionsUM,
                                        label: "UM2",
                                        style: {"width":"100px"}
                                      }, null, 8, ["modelValue", "options"])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _hoisted_57,
                                    _createVNode(_component_draggable, {
                                      class: "list-group",
                                      list: _ctx.listDimensionsNotUsed,
                                      group: "people",
                                      itemKey: "value"
                                    }, {
                                      item: _withCtx(({ element}) => [
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("span", _hoisted_59, _toDisplayString(element.label), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["list"])
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createVNode(_component_draggable, {
                                      class: "list-group",
                                      list: _ctx.listDimensionsUsed,
                                      group: "people",
                                      itemKey: "value"
                                    }, {
                                      item: _withCtx(({ element, index }) => [
                                        _createElementVNode("div", _hoisted_62, [
                                          _createElementVNode("span", _hoisted_63, _toDisplayString(element.label), 1),
                                          _hoisted_64,
                                          _createElementVNode("span", _hoisted_65, "pe pozitia " + _toDisplayString(index+1), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["list"])
                                  ]),
                                  _hoisted_66
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_q_btn, {
                              label: "Reset",
                              type: "reset",
                              color: "primary",
                              flat: "",
                              class: "q-ml-sm"
                            }),
                            _createVNode(_component_q_btn, {
                              label: "Submit",
                              type: "submit",
                              color: "primary"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit", "onReset"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}